export default "__VITE_ASSET__BSMgqQwo__"